import { Headers } from '@egw/components'
import { CheckingAccountRedesignPage } from '@egw/features-account'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const CheckingAccountPage: FC = () => {
  const { t } = useTranslation()

  const { alias } = useParams<{ alias: string }>()

  if (!alias) return null

  return (
    <Layout>
      <Headers title={t('pages.checking.title')} />
      <CheckingAccountRedesignPage alias={parseInt(alias)} />
    </Layout>
  )
}
